var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var PATHTOJSON = window.PATHTOJSON || '/data.json';
document.addEventListener('DOMContentLoaded', initCalculator);
function getData() {
    return __awaiter(this, void 0, void 0, function () {
        var dataUrl, response, data;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    dataUrl = PATHTOJSON;
                    return [4 /*yield*/, fetch(dataUrl)];
                case 1:
                    response = _a.sent();
                    if (!response.ok) {
                        throw new Error("fetch error: ".concat(response.status));
                    }
                    return [4 /*yield*/, response.json()];
                case 2:
                    data = _a.sent();
                    return [2 /*return*/, data];
            }
        });
    });
}
function initCalculator() {
    return __awaiter(this, void 0, void 0, function () {
        var outputElementId, outputErrorElementId, areaInputElementId, outputElement, outputErrorElement, areaInputElement, _a, shapeList, glazeList, unitPriceList, calculatePrice, onChange_1, container, callback, observer, e_1;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    outputElementId = 'estimate-result';
                    outputErrorElementId = 'estimate-error';
                    areaInputElementId = 'estimate-area-input';
                    outputElement = document.getElementById(outputElementId);
                    outputErrorElement = document.getElementById(outputErrorElementId);
                    areaInputElement = document.getElementById(areaInputElementId);
                    _b.label = 1;
                case 1:
                    _b.trys.push([1, 3, , 4]);
                    return [4 /*yield*/, getData()];
                case 2:
                    _a = _b.sent(), shapeList = _a.shapeList, glazeList = _a.glazeList, unitPriceList = _a.unitPriceList;
                    if (!outputElement || !outputErrorElement || !(areaInputElement instanceof HTMLInputElement)) {
                        throw new Error('cannot find required element');
                    }
                    calculatePrice = createPriceFunction(shapeList, glazeList, unitPriceList);
                    onChange_1 = createOnChangeFunction(areaInputElement, outputElement, outputErrorElement, calculatePrice);
                    container = document.querySelector('.product__info-container') || document.body;
                    if (container) {
                        // 色パレット・釉薬の input に対してchangeイベントを監視
                        container.addEventListener('change', function (e) {
                            var target = e.target;
                            if (!(target instanceof Element))
                                return;
                            var isPalleteInput = target.getAttribute('data-type') === 'color-swatches';
                            var isColorInput = target.getAttribute('data-type') === 'image-swatches';
                            if (isPalleteInput || isColorInput) {
                                onChange_1();
                            }
                        });
                        callback = function (mutationsList) {
                            for (var _i = 0, mutationsList_1 = mutationsList; _i < mutationsList_1.length; _i++) {
                                var mutation = mutationsList_1[_i];
                                // 子要素の追加（childList）をチェック
                                if (mutation.type === 'childList') {
                                    mutation.addedNodes.forEach(function (node) {
                                        // 要素ノードかつ、タグ名が VARIANT-SELECTS か確認
                                        if (node instanceof Element && node.tagName === 'VARIANT-SELECTS') {
                                            onChange_1();
                                        }
                                    });
                                }
                            }
                        };
                        observer = new MutationObserver(callback);
                        observer.observe(container, {
                            childList: true, // 子要素の追加・削除を監視
                            subtree: true // ネストされた variant-selects の差し替えも検知
                        });
                    }
                    // 面積 input のinputイベントを監視
                    areaInputElement.addEventListener('input', onChange_1);
                    return [3 /*break*/, 4];
                case 3:
                    e_1 = _b.sent();
                    if (e_1 instanceof Error) {
                        if (outputElement) {
                            outputElement.innerText = '0';
                        }
                        if (outputErrorElement) {
                            outputErrorElement.innerText = e_1.message;
                        }
                    }
                    else {
                        console.error("Unknown error:", e_1);
                    }
                    return [3 /*break*/, 4];
                case 4: return [2 /*return*/];
            }
        });
    });
}
function getUnitPrice(areaSquareMeter, priceList, method) {
    var list = priceList[method];
    function calculateNonListedPrice(areaSquareMeter, priceList) {
        var _a, _b;
        var low = priceList.reduce(function (accum, item) {
            return (!accum || accum < item.area) && item.area <= areaSquareMeter
                ? item.area
                : accum;
        }, undefined);
        var heigh = priceList.reduce(function (accum, item) {
            return (!accum || accum > item.area) && item.area >= areaSquareMeter
                ? item.area
                : accum;
        }, undefined);
        // console.log(low, heigh);
        var priceLow = low && ((_a = priceList.find(function (item) { return item.area === low; })) === null || _a === void 0 ? void 0 : _a.unitPrice);
        var priceHeigh = heigh && ((_b = priceList.find(function (item) { return item.area === heigh; })) === null || _b === void 0 ? void 0 : _b.unitPrice);
        if (!priceLow && !priceHeigh) {
            console.error("cannot get unit price for areaSquareMeter:".concat(areaSquareMeter, " and method:").concat(method));
        }
        // console.log(
        // 	`calculate unit price between "${low}m^2 -> ${priceLow}" and "${heigh}m^2 -> ${priceHeigh}"`,
        // );
        return priceLow && priceHeigh && priceLow !== priceHeigh
            ? priceLow +
                ((priceHeigh - priceLow) / (heigh - low)) * (areaSquareMeter - low)
            : priceLow || priceHeigh;
    }
    return calculateNonListedPrice(areaSquareMeter, list);
}
function createPriceFunction(shapeList, glazeList, priceList) {
    return function calculatePrice(shapeId, glazeId, areaSquareMeter) {
        var minAreaInput = 10;
        if (areaSquareMeter < minAreaInput) {
            throw new Error("".concat(minAreaInput, "m2 \u4EE5\u4E0A\u306E\u5024\u3092\u5165\u529B\u3057\u3066\u304F\u3060\u3055\u3044\u3002"));
        }
        var shapeData = shapeList.find(function (item) { return item.id === shapeId; });
        if (!shapeData) {
            throw new Error("\u7533\u3057\u8A33\u3054\u3056\u3044\u307E\u305B\u3093\u3001\u3053\u306E\u30BF\u30A4\u30EB\u306F\u81EA\u52D5\u304A\u898B\u7A4D\u308A\u306B\u5BFE\u5FDC\u3057\u3066\u304A\u308A\u307E\u305B\u3093\u3002");
        }
        var glazeData = glazeList.find(function (item) { return item.id === glazeId; });
        if (!glazeData) {
            throw new Error("\u7533\u3057\u8A33\u3054\u3056\u3044\u307E\u305B\u3093\u3001\u3053\u306E\u8272\u306F\u81EA\u52D5\u304A\u898B\u7A4D\u308A\u306B\u5BFE\u5FDC\u3057\u3066\u304A\u308A\u307E\u305B\u3093\u3002");
        }
        var method = shapeData.method;
        var unitPrice = (getUnitPrice(areaSquareMeter, priceList, method) || 0) * shapeData.ratio;
        if (!unitPrice) {
            throw new Error("\u7533\u3057\u8A33\u3054\u3056\u3044\u307E\u305B\u3093\u3001\u3054\u6307\u5B9A\u306E\u9762\u7A4D\u3067\u306E\u304A\u898B\u7A4D\u308A\u304C\u3067\u304D\u307E\u305B\u3093\u3067\u3057\u305F\u3002");
        }
        var cost = unitPrice * areaSquareMeter + glazeData.price * areaSquareMeter;
        var result = Math.ceil(cost / 0.6 / 1000) * 1000; // 1000円単位に切り上げ
        return result;
    };
}
function createOnChangeFunction(areaInputElement, outputElement, outputErrorElement, calculatePrice) {
    return function onChange() {
        var shapeId = getShapeId();
        var glazeId = getGlazeId();
        var areaSquareMeter = Number(areaInputElement.value);
        if (!(shapeId && glazeId && areaSquareMeter)) {
            outputElement.innerText = '0';
            outputErrorElement.innerText = '';
            return;
        }
        try {
            var result = calculatePrice(shapeId, glazeId, areaSquareMeter);
            outputElement.innerText = result.toLocaleString('ja-JP');
            outputErrorElement.innerText = '';
        }
        catch (e) {
            if (e instanceof Error) {
                outputElement.innerText = '0';
                outputErrorElement.innerText = e.message;
            }
        }
    };
}
function getShapeId() {
    var scriptElement = document.querySelector('[data-selected-variant]');
    if (!(scriptElement instanceof HTMLElement)) {
        console.log("cannot find shape id");
        return undefined;
    }
    var selectedVariant = scriptElement && JSON.parse(scriptElement.textContent);
    var targetKey = 'sku';
    var shapeId = selectedVariant === null || selectedVariant === void 0 ? void 0 : selectedVariant[targetKey];
    return typeof (shapeId) === 'string' ? shapeId : undefined; // currently do not care String instance
}
function getGlazeId() {
    // 選択中のinput を取得する。HTMLの checked属性ではなく、:checked 擬似要素を利用する。
    var selectedColor = document.querySelector('input[data-type="image-swatches"]:checked');
    if (!(selectedColor instanceof HTMLElement)) {
        console.log("cannot find glaze id");
        return undefined;
    }
    return selectedColor.getAttribute('value') || undefined;
}


(function() {
  var downloadBtn = document.getElementById('estimate-download-btn');
  if (!downloadBtn) return;

  function openEstimatePage() {
    // Collect all data
    var productTitle = document.getElementById('estimate-wrapper')?.dataset.productTitle || '';
    var area = document.getElementById('estimate-area-input')?.value || '';
    var result = document.getElementById('estimate-result')?.innerText || '0';
    var wrapper = document.getElementById('estimate-wrapper');
    var productTitle = wrapper?.dataset.productTitle || '';
    var productCollection = wrapper?.dataset.productCollection || '';
    var productImage = wrapper?.dataset.productImage || '';
    var productNotes = wrapper?.dataset.productNotes || '';

    var displayTitle = productCollection 
    ? productCollection + ' - ' + productTitle 
    : productTitle;

    // Get 面状 from selected variant SKU
    var shapeId = getShapeId() || '';

    // Get globo color
    var glazeId = getGlazeId() || '';

    // Get color label and swatch image from the checked label
    var colorLabel = '';
    var colorImage = '';
    var checkedColor = document.querySelector('input[data-type="image-swatches"]:checked');
    if (checkedColor) {
      var label = document.querySelector('label[for="' + checkedColor.id + '"]');
      colorLabel = label?.querySelector('.variant-image-tile__label')?.textContent?.trim() || glazeId;
      colorImage = label?.querySelector('img')?.src || '';
    }

    // Get 面状 display label from checked radio
    var shapeLabel = '';
    var checkedShape = document.querySelector('input[name="面状-1"]:checked');
    if (checkedShape) shapeLabel = checkedShape.value;

    var variantTitleEl = document.querySelector('[id^="variant-featured-title-"]');
    if (variantTitleEl && variantTitleEl.textContent.trim()) {
    shapeLabel = variantTitleEl.textContent.trim();
    }

    // Get 面状 image
    var shapeImage = productImage;
    var variantImageContainer = document.querySelector('[id^="variant-featured-image-"]');
    var variantImageEl = document.querySelector('[id^="variant-featured-img-"]');
    if (variantImageContainer && variantImageContainer.style.display !== 'none' && variantImageEl?.src) {
      shapeImage = variantImageEl.src;
    }

    // Get metafields for surface and molding model numbers
    var surfaceModelNumber = '';
    var moldingSizeModelNumber = '';
    var metafieldsEl = document.getElementById('variant-metafields-data');
    if (metafieldsEl) {
    var metafieldsData = JSON.parse(metafieldsEl.textContent);
    // Get current variant ID from the selected variant script tag
    var selectedVariantEl = document.querySelector('[data-selected-variant]');
    var selectedVariant = selectedVariantEl ? JSON.parse(selectedVariantEl.textContent) : null;
    var variantId = selectedVariant?.id?.toString();
    var variantEntry = variantId ? metafieldsData[variantId] : null;
    if (variantEntry) {
        surfaceModelNumber = variantEntry.surfaceModelNumber || '';
        moldingSizeModelNumber = variantEntry.moldingSizeModelNumber || '';
    }
    }

    var modelParts = [surfaceModelNumber, moldingSizeModelNumber].filter(Boolean);
    var modelNumber = modelParts.join('_');
    var shapeParam = [shapeLabel || shapeId, modelNumber].filter(Boolean).join(' ');

    // Build URL
    var params = new URLSearchParams({
        title: displayTitle,
        image: productImage,
        shape: shapeParam,
        shapeImage: shapeImage,
        color: colorLabel || glazeId,
        colorImage: colorImage,
        area: area,
        price: result,
        date: (function() {
        var now = new Date();
        var lang = document.documentElement.lang || 'en';
        if (lang === 'ja') {
            var y = now.getFullYear();
            var m = String(now.getMonth() + 1).padStart(2, '0');
            var d = String(now.getDate()).padStart(2, '0');
            return y + '-' + m + '-' + d;
        }
        return now.toLocaleDateString('en-US', { year: 'numeric', month: 'long', day: 'numeric' });
        })(),
        notes: productNotes
    });

    if (window.Shopify && window.Shopify.analytics && typeof window.Shopify.analytics.publish === 'function') {
      window.Shopify.analytics.publish('estimate_download_click', {
        product_title: displayTitle,
        shape: shapeParam,
        color: colorLabel || glazeId,
        area: area,
        price: result
      });
    }

    var locale = document.documentElement.lang || 'ja';
    var basePath = locale === 'ja' ? '/pages/estimate-print' : '/' + locale + '/pages/estimate-print';
    window.open(basePath + '?' + params.toString(), '_blank');
  }

  downloadBtn.addEventListener('click', openEstimatePage);
})();